import type { Story } from '@shared/api/types/story';
import { ACTION_TYPES, STATUS_TYPES } from '@shared/api/types/story';

export const popSocialExclusiveCampaignWin25000Shib5750000Giveaway: Story = {
  id: 'pop-social-exclusive-campaign-win-25000-shib-5750000-giveaway',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Pop social exclusive campaign win 25000 shib 5750000 giveaway',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Campaign: Earn 25,000 $SHIB in the Pop Social Campaign',
      description:
        'Join the web3 world at Magic Store by Magic Square. Earn 25,000 $SHIB by completing the Pop Social Campaign plus get a chance to win from a 5,750,000 $SHIB giveaway prize pool',
      keywords:
        'Web3, Crypto, Hot Offer, Magic Store, Magic Square, Pop Social Campaign, SHIB, Web3 App Store, Decentralized Apps, Crypto Rewards, Pop Social, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: 'd3cb780b5d01659ac2007a5984bb1d1b346d',
      scode: 'MagicSquare',
      ccode: 'EDOIYUC8fX',
    },
  },
};
